import * as qs from 'querystring';
import { withoutUndefinedValues } from '../util/withoutUndefinedValues';

export const addQueryParams = (
  url: string,
  params: Record<string, string | string[] | undefined>,
) => {
  const encoded = qs.encode(withoutUndefinedValues(params));
  if (encoded.length === 0) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${encoded}`;
};
